import {
    SYNCHRO_GET_API_HABILITATIONS,
    IS_LOADING,
} from './habilitationsConstants';
import { throwErrorMessage } from '../../lib/error_helper';
import {fetchWithTimeout} from '../../lib/fetch_wrapper';

export function habilitationsIsLoading(bool) {
    return {
        type: IS_LOADING,
        info: 'Récupération des habilitations',
        isLoading: bool
    };
}

export function getHabilitations(empId) {
    return (dispatch) => {
        dispatch(habilitationsIsLoading(true));
        const headers = new Headers({'Content-Type': 'application/json'});
        fetchWithTimeout('/api/v1/habilitation/all/' + empId, {
            method: 'GET',
            headers: headers
        })
            .then((response) => {
                dispatch(habilitationsIsLoading(false));
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                return response;
            })
            .then((response) => response.json())
            .then((habilitations) => dispatch(habilitationsFetchDataSuccess(habilitations)))
            .catch((err) => {
                console.error("Erreur : habilitationsActions - getHabilitations", err)
                dispatch(throwErrorMessage({
                    errorObject: err,
                    title: "Erreur",
                    message: "Erreur lors de la récupération des habilitations !",
                }))
                dispatch(habilitationsIsLoading(false));
            });
    };
}

export function habilitationsFetchDataSuccess(habilitations) {
    return {
        type: SYNCHRO_GET_API_HABILITATIONS,
        habilitations: habilitations
    };
}
